import * as React from 'react'

function IconLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={45}
      height={45}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.077 17.923a7.612 7.612 0 010 10.763L16.249 39.513a7.612 7.612 0 01-10.763 0 7.612 7.612 0 010-10.762l3.242-3.242"
        stroke="#219321"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.923 27.077a7.612 7.612 0 010-10.763L28.75 5.487a7.612 7.612 0 0110.762 0 7.612 7.612 0 010 10.762l-3.241 3.242"
        stroke="#219321"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconLink
